import { useTranslation } from "react-i18next";
import useAnimateCss from "../../hooks/useAnimateCss";


import img1 from "../../assets/images/sponsors/1.png";
import img3 from "../../assets/images/sponsors/3.png";
import img4 from "../../assets/images/sponsors/4.png";
import img5 from "../../assets/images/sponsors/5.png";
import img6 from "../../assets/images/sponsors/6.png";
import arabia from "../../assets/images/sponsors/arabia.png";
import concord from "../../assets/images/sponsors/concord.png";
import nat from "../../assets/images/sponsors/nat.png";
import sodic from "../../assets/images/sponsors/sodic.png";
import tatweer from "../../assets/images/sponsors/tatweer.png";
import nile from "../../assets/images/quality/certifications/nile.png";
import petrojet from "../../assets/images/quality/certifications/pertrojet.jpg";
import redcon from "../../assets/images/quality/certifications/redcon.png";
import tag from "../../assets/images/quality/certifications/tag misr.png";
import TMG from "../../assets/images/quality/certifications/TMG.webp";

const logos = [
  img1,
  img3,
  img4,
  img5,
  img6,
  arabia,
  concord,
  nat,
  sodic,
  tatweer,
  nile,
  petrojet,
  redcon,
  tag,
  TMG,
];

function SponsersForHomePage() {
  const { t } = useTranslation();
  const headRef    = useAnimateCss("animate__fadeInDown", 0,   0.15);
  const marqueeRef = useAnimateCss("animate__fadeIn",     200, 0.10, 900);

  return (
    <section className="sponsors-section">
      <div className="text-center mb-5">
        <h2 className="sponsors-eyebrow" ref={headRef as any}>{t("trusted partners")}</h2>
      </div>

      {/* Marquee track — full bleed, outside container */}
      <div className="sponsors-marquee-wrapper" ref={marqueeRef as any}>
        {/* edge fades */}
        <div className="sponsors-fade sponsors-fade-left" />
        <div className="sponsors-fade sponsors-fade-right" />

        <div className="sponsors-marquee-track">
          {/* duplicated for seamless loop */}
          {[...logos, ...logos].map((src, i) => (
            <div key={i} className="sponsor-item">
              <img
                src={src}
                alt={`Partner ${i + 1}`}
                className="sponsor-logo"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default SponsersForHomePage;
